import { IconAirplaneCircle, IconCarCircle } from '@shared/icons'
import {
  convertTimestampToDuration,
  toThousandSeparator,
} from '@shared/innmaxLib/utils/webHelper'
import { Divider } from 'antd'
import { pathOr } from 'ramda'
import MobilePageDrawer, {
  IMobilePageDrawerProps,
} from 'src/components/MobilePageDrawer'
import { IQueryMode } from '.'

const DataRow = ({
  label,
  value,
}: {
  label: string
  value?: number | string
}) => (
  <div className="flex text-primary gap-10">
    <label>{label}</label>
    <label>|</label>
    <label className="text-white">{value}</label>
  </div>
)

const DetailPage = (
  props: Omit<IMobilePageDrawerProps, 'children'> & {
    data: any
    queryMode: IQueryMode
  }
) => {
  const { data, queryMode, ...others } = props

  const detailDataValue = (key: string): any => pathOr('-', [key], data)

  return (
    <MobilePageDrawer title={data?.orgSessionName} {...others}>
      <div className="flex justify-between text-lg">
        <div className="text-white flex items-center gap-5">
          <div className="text-primary">
            {queryMode === 'rawData' ? (
              <IconCarCircle />
            ) : (
              <IconAirplaneCircle />
            )}
          </div>
          <div>
            {queryMode === 'rawData' ? data?.lprNumber : data?.orgSessionName}
          </div>
        </div>
        <div className="text-primary">
          總費用: {toThousandSeparator(detailDataValue('totalAmount'))}
        </div>
      </div>
      <Divider className="border-primary" />
      <div className="flex flex-col gap-5">
        <div className="text-white opacity-50">一般時段</div>
        <DataRow
          label="充電度數"
          value={toThousandSeparator(detailDataValue('offPeakDegree'))}
        />
        <DataRow
          label="充電時長"
          value={convertTimestampToDuration(detailDataValue('offPeakDuration'))}
        />
        <DataRow
          label="充電費"
          value={toThousandSeparator(detailDataValue('offPeakFee'))}
        />
      </div>
      <Divider className="border-primary" />
      <div className="flex flex-col gap-5">
        <div className="text-white opacity-50">壅塞時段</div>
        <DataRow
          label="充電度數"
          value={toThousandSeparator(detailDataValue('peakDegree'))}
        />
        <DataRow
          label="充電時長"
          value={convertTimestampToDuration(detailDataValue('peakDuration'))}
        />
        <DataRow
          label="充電費"
          value={toThousandSeparator(detailDataValue('peakFee'))}
        />
      </div>
      <Divider className="border-primary" />
      <div className="flex flex-col gap-5">
        <DataRow
          label="佔用時間"
          value={convertTimestampToDuration(
            detailDataValue('occupationDuration'),
            'H時:m分'
          )}
        />
        <DataRow
          label="佔用費"
          value={toThousandSeparator(detailDataValue('occupationFee'))}
        />
        {queryMode === 'summary' && (
          <>
            <DataRow
              label="優惠費率"
              value={toThousandSeparator(detailDataValue('discountFee'))}
            />
            <DataRow
              label="優惠費用"
              value={toThousandSeparator(detailDataValue('discountAmount'))}
            />
            <DataRow
              label="短溢收金額"
              value={toThousandSeparator(detailDataValue('adjustAmount'))}
            />
          </>
        )}
      </div>
    </MobilePageDrawer>
  )
}

export default DetailPage
